import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { ChevronsUpDown, Check } from "lucide-react";
import { cn } from "@/lib/utils";
import { useSearchOrganisationsQuery } from "@/store/admin_api";
import Organisation from "@/model/interface/Organisation";
import React from "react";

interface OrganisationComboboxProps {
  value: Organisation | null;
  onChange: (org: Organisation | null) => void;
}

export default function OrganisationCombobox({ value, onChange }: OrganisationComboboxProps) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");

  const { data: results, isFetching } = useSearchOrganisationsQuery(search, {
    skip: search.length < 2,
  });

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" role="combobox" aria-expanded={open} className="w-[320px] justify-between">
          {value ? value.name : "Select organisation..."}
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[320px] p-0">
        <Command shouldFilter={false}>
          <CommandInput placeholder="Search organisations..." value={search} onValueChange={setSearch} />
          <CommandList>
            <CommandEmpty>{isFetching ? "Searching..." : search.length < 2 ? "Type to search..." : "No organisations found."}</CommandEmpty>
            <CommandGroup>
              {results?.map((org) => (
                <CommandItem
                  key={org.id}
                  value={org.id}
                  onSelect={() => {
                    onChange(org.id === value?.id ? null : org);
                    setOpen(false);
                  }}
                >
                  <Check className={cn("mr-2 h-4 w-4", value?.id === org.id ? "opacity-100" : "opacity-0")} />
                  {org.name}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
